import { render, staticRenderFns } from "./accumulators-config.vue?vue&type=template&id=8a67b402&scoped=true"
import script from "./accumulators-config.vue?vue&type=script&lang=js"
export * from "./accumulators-config.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./accumulators-config.vue?vue&type=style&index=1&id=8a67b402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67b402",
  null
  
)

export default component.exports